import { LightbulbRegular } from '@fluentui/react-icons';
import { useState } from 'react';
import {
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    ToolbarButton,
} from '@fluentui/react-components';
import { DocPanel } from './DocPanel';

export const DocToolbarLink = () => {
    const [docType, setDocType] = useState<
        | 'juel'
        | 'juel-extensions'
        | 'sp-json'
        | 'sp-odata'
        | 'actions'
        | 'processes'
        | 'booleanUtil'
        | 'collectionUtil'
        | 'conversionUtil'
        | 'dateUtil'
        | 'jsonUtil'
        | 'mathUtil'
        | 'stringUtil'
    >('actions');
    const [openDocumentation, setOpenDocumentation] = useState(false);
    return (
        <>
            <Menu>
                <MenuTrigger disableButtonEnhancement>
                    <ToolbarButton aria-label="Hilfe" icon={<LightbulbRegular />}>
                        Hilfe
                    </ToolbarButton>
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>
                        <MenuItem
                            aria-label="Aktionen"
                            onClick={() => {
                                setDocType('actions');
                                setOpenDocumentation(true);
                            }}
                        >
                            Aktionen
                        </MenuItem>
                        <MenuItem
                            aria-label="Prozesse"
                            onClick={() => {
                                setDocType('processes');
                                setOpenDocumentation(true);
                            }}
                        >
                            Prozesse
                        </MenuItem>
                        <MenuItem
                            aria-label="Juel Expressions"
                            onClick={() => {
                                setDocType('juel');
                                setOpenDocumentation(true);
                            }}
                        >
                            JUEL Grundlagen
                        </MenuItem>
                        <JuelExtensions
                            setDocType={setDocType}
                            setOpenDocumentation={setOpenDocumentation}
                        />
                        <MenuItem
                            aria-label="Listenfilter"
                            onClick={() => {
                                setDocType('sp-odata');
                                setOpenDocumentation(true);
                            }}
                        >
                            Listenfilter
                        </MenuItem>
                        <MenuItem
                            aria-label="Listitem erstellen"
                            onClick={() => {
                                setDocType('sp-json');
                                setOpenDocumentation(true);
                            }}
                        >
                            Listitem erstellen
                        </MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
            <DocPanel docType={docType} open={openDocumentation} setOpen={setOpenDocumentation} />
        </>
    );
};

const JuelExtensions = ({
    setDocType,
    setOpenDocumentation,
}: {
    setDocType: (
        type:
            | 'juel'
            | 'juel-extensions'
            | 'sp-json'
            | 'sp-odata'
            | 'actions'
            | 'processes'
            | 'booleanUtil'
            | 'collectionUtil'
            | 'conversionUtil'
            | 'dateUtil'
            | 'jsonUtil'
            | 'mathUtil'
            | 'stringUtil'
    ) => void;
    setOpenDocumentation: (open: boolean) => void;
}) => {
    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuItem
                    aria-label="JUEL Erweiterungen"
                    onClick={() => {
                        setDocType('juel-extensions');
                        setOpenDocumentation(true);
                    }}
                >
                    JUEL Erweiterungen
                </MenuItem>
            </MenuTrigger>

            <MenuPopover>
                <MenuList>
                    <MenuItem
                        aria-label="BooleanUtil"
                        onClick={() => {
                            setDocType('booleanUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Boolesche Operationen (boolUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="CollectionUtil"
                        onClick={() => {
                            setDocType('collectionUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Listen-Operationen (collectionUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="ConversionUtil"
                        onClick={() => {
                            setDocType('conversionUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Konvertierung (conversionUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="DateUtil"
                        onClick={() => {
                            setDocType('dateUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Date & Time (dateUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="JsonUtil"
                        onClick={() => {
                            setDocType('jsonUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        JSON-Operationen (jsonUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="MathUtil"
                        onClick={() => {
                            setDocType('mathUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Mathematische Operationen (mathUtil)
                    </MenuItem>
                    <MenuItem
                        aria-label="StringUtil"
                        onClick={() => {
                            setDocType('stringUtil');
                            setOpenDocumentation(true);
                        }}
                    >
                        Text-Operationen (stringUtil)
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};
